module.exports = __webpack_public_path__ + "static/img/request-a-demo.ecf53ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/request-a-demo.png
// module id = sucp
// module chunks = 0